(function() {
  'use strict';

  // 販売期間管理クラス（機能強化版）
  class ProductSalesPeriodManager {
    constructor() {
      this.salesPeriodData = null;
      this.addToCartButtons = [];
      this.paymentButtons = [];
      this.notifyButton = null;
      this.isInitialized = false;
      
      this.init();
    }

    async init() {
      if (Shopify.designMode) if (Shopify.designMode) console.log('[SalesPeriod] 初期化開始');
      
      // 販売期間データを読み込み
      this.loadSalesPeriodData();
      
      // ボタン要素を取得
      this.findButtons();
      
      // 通知ボタンの初期化
      //this.initializeNotifyButton();
      
      // 初期状態を設定
      this.updateButtonStates();
      
      // イベントリスナーを設定
      this.attachEventListeners();
      
      this.isInitialized = true;
      if (Shopify.designMode) if (Shopify.designMode) console.log('[SalesPeriod] 初期化完了', this.salesPeriodData);
    }

    // 販売期間データを読み込み
    loadSalesPeriodData() {
      const dataElement = document.getElementById('product-sales-period-data');
      if (dataElement) {
        try {
          this.salesPeriodData = JSON.parse(dataElement.textContent);
          if (Shopify.designMode) console.log('[SalesPeriod] データ読み込み完了:', this.salesPeriodData);
        } catch (error) {
          if (Shopify.designMode) console.error('[SalesPeriod] データ読み込みエラー:', error);
          this.salesPeriodData = { isActive: true };
        }
      } else {
        if (Shopify.designMode) console.log('[SalesPeriod] データ要素が見つかりません - 制限なし');
        this.salesPeriodData = { isActive: true };
      }
    }

    // ボタン要素を検索
    findButtons() {
      // カートに追加ボタン（更新）
      this.addToCartButtons = document.querySelectorAll(
        '.product-form__submit, button[name="add"], [data-cart-add]'
      );

      // 支払いボタン（Shopify Payments、PayPal等）
      this.paymentButtons = document.querySelectorAll(
        '.shopify-payment-button button, .additional-checkout-buttons button, .dynamic-checkout-disabled button'
      );

      if (Shopify.designMode) console.log('[SalesPeriod] ボタン要素を検索:', {
        addToCartButtons: this.addToCartButtons.length,
        paymentButtons: this.paymentButtons.length
      });
    }

    // 商品IDを取得
    getProductId() {
      // 商品ページのURLから取得
      const pathParts = window.location.pathname.split('/');
      if (pathParts.includes('products') && pathParts.length >= 3) {
        return pathParts[pathParts.indexOf('products') + 1];
      }
      
      // フォームの隠しフィールドから取得を試行
      const variantInput = document.querySelector('input[name="id"]');
      if (variantInput && variantInput.value) {
        return variantInput.value.split('-')[0]; // バリアントIDから商品IDを推測
      }
      
      return null;
    }

    // 通知登録成功メッセージの表示
    showNotificationSuccess(email) {
      const successMessage = document.createElement('div');
      successMessage.className = 'notification-success status-message status-message--success';
      successMessage.innerHTML = `
        <h4>通知登録完了</h4>
        <p><strong>${email}</strong> に販売開始をお知らせします。</p>
        <p>販売開始時にメールでご連絡いたします。</p>
      `;
      
      // 通知ボタンの後に挿入
      if (this.notifyButton && this.notifyButton.parentNode) {
        this.notifyButton.parentNode.insertBefore(successMessage, this.notifyButton.nextSibling);
        
        // 通知ボタンを非表示
        this.notifyButton.style.display = 'none';
      }
      
      // 5秒後に自動的に非表示
      setTimeout(() => {
        if (successMessage.parentNode) {
          successMessage.parentNode.removeChild(successMessage);
        }
      }, 5000);
    }

    // ボタンの状態を更新
    updateButtonStates() {
      if (!this.salesPeriodData || this.salesPeriodData.isActive) {
        this.enableAllButtons();
        return;
      }

      // 販売期間外の場合はボタンを無効化
      this.disableAllButtons();
    }

    // すべてのボタンを有効化
    enableAllButtons() {
      [...this.addToCartButtons, ...this.paymentButtons].forEach(button => {
        // aria-describedby属性で販売期間制限を確認
        if (button.getAttribute('aria-describedby') === 'sales-period-restriction') {
          button.disabled = false;
          button.style.opacity = '';
          button.style.cursor = '';
          button.style.pointerEvents = '';
          
          // ARIA属性をリセット
          button.removeAttribute('aria-disabled');
          button.removeAttribute('aria-describedby');
          
          // 無効化時に追加したクラスを削除
          button.classList.remove('sales-period-disabled');
        }
      });

      if (Shopify.designMode) console.log('[SalesPeriod] 販売期間制限ボタンを有効化');
    }

    // すべてのボタンを無効化
    disableAllButtons() {
      [...this.addToCartButtons, ...this.paymentButtons].forEach(button => {
        // 既にaria-describedbyで制限されているボタンのみ対象
        if (button.getAttribute('aria-describedby') === 'sales-period-restriction') {
          button.disabled = true;
          button.style.opacity = '0.5';
          button.style.cursor = 'not-allowed';
          button.style.pointerEvents = 'none';
          
          // 視覚的な無効化クラスを追加
          button.classList.add('sales-period-disabled');
          
          // クリックイベントを阻止
          button.addEventListener('click', this.preventClick.bind(this), true);
        }
      });

      if (Shopify.designMode) console.log('[SalesPeriod] 販売期間制限ボタンを無効化');
    }

    // クリックを阻止
    preventClick(event) {
      if (!this.salesPeriodData || !this.salesPeriodData.isActive) {
        event.preventDefault();
        event.stopImmediatePropagation();
        
        // ユーザーフィードバック
        this.showClickFeedback(event.target);
        
        return false;
      }
    }

    // クリック時のフィードバック表示
    showClickFeedback(button) {
      // スクリーンリーダー用のアナウンス
      this.announceToScreenReader(
        this.salesPeriodData.statusMessage || '現在この商品は購入できません'
      );

      // 視覚的なフィードバック（ボタンを軽く震わせる）
      button.classList.add('sales-period-shake');
      setTimeout(() => {
        button.classList.remove('sales-period-shake');
      }, 300);
    }

    // 現在時刻と販売期間を再チェック
    recheckSalesPeriod() {
      if (!this.salesPeriodData || (!this.salesPeriodData.startDate && !this.salesPeriodData.endDate)) {
        return;
      }

      const now = Math.floor(Date.now() / 1000);
      let isActive = true;

      // 販売開始時刻チェック
      if (this.salesPeriodData.startDate) {
        const startTime = new Date(this.salesPeriodData.startDate).getTime() / 1000;
        if (now < startTime) {
          isActive = false;
        }
      }

      // 販売終了時刻チェック
      if (this.salesPeriodData.endDate) {
        const endTime = new Date(this.salesPeriodData.endDate).getTime() / 1000;
        if (now > endTime) {
          isActive = false;
        }
      }

      // 状態が変更された場合のみ更新
      if (isActive !== this.salesPeriodData.isActive) {
        if (Shopify.designMode) console.log('[SalesPeriod] 販売期間状態変更:', isActive);
        this.salesPeriodData.isActive = isActive;
        this.updateButtonStates();
        
        // 販売開始時の特別処理
        if (isActive && this.salesPeriodData.statusType === 'warning') {
          this.handleSalesStart();
        }
      }
    }

    // 販売開始時の処理
    handleSalesStart() {
      // ページをリロードして最新状態を反映
      if (Shopify.designMode) console.log('[SalesPeriod] 販売開始を検出、ページを更新します');
      
      // 販売開始アナウンス
      this.announceToScreenReader('商品の販売が開始されました。ページを更新しています。');
      
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    }

    // イベントリスナーの設定
    attachEventListeners() {
      // 商品バリエーション変更時の再チェック
      document.addEventListener('variant:change', () => {
        if (Shopify.designMode) console.log('[SalesPeriod] バリエーション変更検出');
        setTimeout(() => {
          this.findButtons();
          this.updateButtonStates();
        }, 100);
      });

      // 定期的な販売期間チェック（1分間隔）
      setInterval(() => {
        this.recheckSalesPeriod();
      }, 60000);

      // ページ表示時の再チェック
      document.addEventListener('visibilitychange', () => {
        if (!document.hidden) {
          this.recheckSalesPeriod();
        }
      });

      // カート更新イベントとの連携
      document.addEventListener('cart:updated', () => {
        // カート更新時も販売期間チェックを維持
        setTimeout(() => {
          this.updateButtonStates();
        }, 100);
      });
    }

    // スクリーンリーダー用のアナウンス
    announceToScreenReader(message) {
      const announcement = document.createElement('div');
      announcement.setAttribute('aria-live', 'assertive');
      announcement.setAttribute('aria-atomic', 'true');
      announcement.style.position = 'absolute';
      announcement.style.left = '-10000px';
      announcement.style.width = '1px';
      announcement.style.height = '1px';
      announcement.style.overflow = 'hidden';
      announcement.textContent = message;
      
      document.body.appendChild(announcement);
      
      setTimeout(() => {
        if (announcement.parentNode) {
          announcement.parentNode.removeChild(announcement);
        }
      }, 1000);
    }

    // 外部からの状態確認用メソッド
    isSalesPeriodActive() {
      return this.salesPeriodData ? this.salesPeriodData.isActive : true;
    }

    // デバッグ用の状態確認
    getDebugInfo() {
      return {
        salesPeriodData: this.salesPeriodData,
        addToCartButtonCount: this.addToCartButtons.length,
        paymentButtonCount: this.paymentButtons.length,
        hasNotifyButton: !!this.notifyButton,
        isInitialized: this.isInitialized
      };
    }
  }

  // CSS アニメーション追加
  if (!document.querySelector('#sales-period-animations')) {
    const style = document.createElement('style');
    style.id = 'sales-period-animations';
    style.textContent = `
      .notification-success {
        background: rgba(40, 167, 69, 0.1) !important;
        color: #155724 !important;
        border-left-color: #28a745 !important;
        margin: 16px 0 !important;
        padding: 16px !important;
        border-radius: 8px !important;
        border-left: 4px solid #28a745 !important;
      }
      
      .notification-success h4 {
        margin: 0 0 8px 0 !important;
        color: #155724 !important;
        font-size: 1.6rem !important;
        font-weight: 600 !important;
      }
      
      .notification-success p {
        margin: 4px 0 !important;
        color: #155724 !important;
        font-size: 1.4rem !important;
      }
    `;
    document.head.appendChild(style);
  }

  // グローバルインスタンス
  let productSalesPeriodManager = null;

  // 初期化関数
  function initProductSalesPeriod() {
    // 商品ページでのみ実行
    if (document.querySelector('.product-form') || document.querySelector('[data-product-form]')) {
      productSalesPeriodManager = new ProductSalesPeriodManager();
      
      // グローバルアクセス用（デバッグ・外部連携用）
      window.productSalesPeriodManager = productSalesPeriodManager;
    }
  }

  // DOMContentLoaded時に初期化
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductSalesPeriod);
  } else {
    initProductSalesPeriod();
  }

  // cart-group-restriction.jsとの連携
  window.addEventListener('cart-restriction-check', function() {
    if (productSalesPeriodManager && !productSalesPeriodManager.isSalesPeriodActive()) {
      const event = new CustomEvent('sales-period-restriction', {
        detail: {
          restricted: true,
          reason: 'sales-period-inactive',
          message: productSalesPeriodManager.salesPeriodData?.statusMessage || '販売期間外'
        }
      });
      window.dispatchEvent(event);
    }
  });

})();